(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('labvalueconfig', {
      restrict: 'E',
      bindings: {
      },
      templateUrl: 'vcpatdocs/labvalueconfig-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', '$timeout',
        function ($log, Config, Rlog, $timeout) {
          let vm = this;


          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};
          vm.saveConfig = saveConfig;
          vm.loadValues = loadValues;
          vm.addGroup = addGroup;
          vm.removeGroup = removeGroup;
          vm.saveConfig = saveConfig;

          vm.$onInit = function () {
            //  get labvalues and groups from config
            Config.$find('labconfiguration').$then(labconfig => {
              if (!labconfig.hasOwnProperty('_id')) {
                labconfig._id = 'labconfiguration';
              }
              if (!labconfig.hasOwnProperty('groups')) {
                labconfig.groups = [];
              }
              if (!labconfig.hasOwnProperty('values')) {
                labconfig.values = [];
              }
              vm.labconfig = labconfig;
            }, error => {
              $log.error('Loading of labconfiguration failed');
              Rlog.error('patdocs', 'labvalueconfig', 'labconfiguration.$find() failed', {id: 'labconfiguration'});
            });
          }; // $onInit()


          function addGroup() {
            // vm.labconfig.groups.push({name: vm.newgroup, values: []});
            vm.labconfig.groups.splice(0, 0, {name: vm.newgroup, values: []});
            vm.labconfig.groups.sort((a, b) => a.name.localeCompare(b.name));
            vm.newgroup = '';
            vm.saveConfig();
          }

          function removeGroup(index) {
            vm.labconfig.groups.splice(index, 1);
            vm.saveConfig();
          }

          function saveConfig() {
            let changedgroups = [];

            vm.labconfig.values = uniq(vm.labconfig.values);
            for (let i = 0; i < vm.labconfig.groups.length; i++){
              changedgroups.push({
                name: vm.labconfig.groups[i].name,
                values: uniq(vm.labconfig.groups[i].values)
              });
            }
            vm.labconfig.groups = changedgroups;
            vm.labconfig.$save();
          }

          function uniq(a) {
            return a.sort().filter(function (item, pos, ary) {
              return !pos || item !== ary[pos - 1];
            });
          }

          // load and filter autocomplete values
          function loadValues($query) {
            let promise = new Promise(function (resolve, reject) {
              resolve(vm.labconfig.values);
            });
            return promise.then(function (values) {
              $log.debug('promise values: ', values);
              let filteredValues = values.filter(function (value) {
                return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
              });
              console.log('filtered values: ', filteredValues);
              return filteredValues;
            });
          }

        }
      ] // controller
    }); // component

// klammerfriedhof
}());
